<div class="wrapper">
  <div *ngIf="(!vars?.pageName?.match('stories|mini_story') && !vars.showStoryOnFundraiser) || (vars.showKCart && !isMobile)" class="content">
    <span *ngIf="!vars.showKCart" class="text">Ketto is charging 0% platform fee* for this fundraiser, relying solely on the generosity of contributors like you. </span>
    <span *ngIf="vars.showKCart" class="text">If you like what we are doing, you can leave us small tip!</span>
    <button type="button" *ngIf="!isMobile" class="info-btn" (mouseenter)="showPopover = true" (mouseleave)="showPopover = false" mat-icon-button>
      <mat-icon>info</mat-icon>
      <div *ngIf="showPopover" [ngTemplateOutlet]="tipInfo"></div>
    </button>
    <span *ngIf="isMobile && !vars.showKCart" class="know-more" (click)="openTipInfo(tipInfo)"> Know more</span>
  </div>
  <div *ngIf="(vars?.pageName === 'stories' || vars.showStoryOnFundraiser) && !(vars.showKCart && !isMobile)" class="content">If you like what we are doing, you can leave us small tip!</div>
  <div *ngIf="vars?.pageName === 'mini_story'" class="content">If you like what we are doing support us by adding a tip of 18%</div>
  <div class="tip" *ngIf="!showToggleAmt">
    <span *ngIf="vars?.pageName !== 'mini_story'" class="text">Support us by adding a tip of :</span>
    <span *ngIf="vars?.pageName === 'mini_story'" class="text">Tip to Ketto Volunteer</span>
    <ng-template *ngIf="!isMobile" [ngTemplateOutlet]="tipSelect"></ng-template>
    <ng-template *ngIf="isMobile" [ngTemplateOutlet]="tipSelectNativ"></ng-template>
  </div>
  <div *ngIf="selectedTip === 0 && !showToggleAmt" class="custom-tipAmount">
    <div class="custom-tip-label" [ngClass]="{'custom-tipAmount-v2': vars.pageName ==='campaign' && vwo.fundraiser_tip_badge_AB()}">
      <label>Tip Amount: </label>
      <span *ngIf="vars.pageName ==='campaign' && vwo.fundraiser_tip_badge_AB()">98% donors have left a tip ⭐️</span>
    </div>
    <mat-form-field class="input-container" [formGroup]="customAmountForm" appearance="outline">
      <input matInput
        type="number"
        min="0"
        [formControl]="customAmount"
        (input)="onInput()">
      <div matPrefix *ngIf="currency">
        <app-currency-icon [currency] = "currency" ></app-currency-icon>
      </div>
    </mat-form-field>
  </div>
  <div class="toggle-div" *ngIf="showToggleAmt">
    <div class="toggle-amt" >
      <span>Give {{noTipDefault}}% of your contribution to Ketto and help more people raise funds for free.</span>
      <mat-slide-toggle (change)="toggle($event)" [checked]="isToggleChecked"></mat-slide-toggle>
    </div>
    <div class="donation">
      Contribution : <app-currency-icon [currency] = "currency" ></app-currency-icon>{{baseAmtToggle}}   +
      Tip : <app-currency-icon [currency] = "currency" ></app-currency-icon>{{tipAmtToggle}}
    </div>
  </div>
  <div *ngIf="amount && !showToggleAmt" class="amount">Total Amount: {{currency +' '+ amount}}</div>
</div>

<!--Tip model UI A/B/C Testing-->
<div *ngIf="false" class="tip-wrapper tip-bg">
  <div class="support-txt">
    <mat-checkbox [(ngModel)]="tipEnable" (change)="onCheckBoxChange($event)" color="primary">Support us by adding a tip</mat-checkbox>
    <div class="free-txt">
      <span>Ketto charges <b>0% fee</b> to campaigners, relying solely on contributor like you.</span>
      <button type="button"  *ngIf="!isMobile" mat-icon-button><mat-icon>info</mat-icon></button>
      <span *ngIf="isMobile" class="know-more" (click)="openTipInfo(tipInfo2)"><mat-icon>info</mat-icon></span>
    </div>
  </div>
  <div class="text-center">
    <button class="pills" *ngFor="let item of tips" (click)="selectTip({value:item.percent})" [ngClass]="{'active-pill': selectedTip === item.percent}" [disabled]="!tipEnable" mat-raised-button>{{item.percent}}%</button>
  </div>
</div>

<ng-template #tipSelect>
  <mat-form-field class="tip-select">
    <mat-select (selectionChange)="selectTip($event); triggerOtherTipEvent($event);" [(value)]="selectedTip">
      <mat-option *ngFor="let tip of tips" [value]="tip.percent">
        <span>
          <span *ngIf="tip.percent > 0">{{tip.percent}}%</span> <span *ngIf="baseAmount || tip.label === 'Other'" class="tip-amount"> {{tip.label}}</span>
        </span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #tipSelectNativ>
  <mat-form-field class="tip-select">
    <select matNativeControl (change)="selectTip($event, true); triggerOtherTipEvent($event, true);" [(value)]="selectedTip">
      <option *ngFor="let tip of tips" [value]="tip.percent" [selected]="selectedTip === tip.percent">
        <span>
          <span *ngIf="tip.percent > 0">{{tip.percent}}%</span> <span *ngIf="baseAmount || tip.label === 'Other'" class="tip-amount"> {{tip.label}}</span>
        </span>
      </option>
    </select>
  </mat-form-field>
</ng-template>

<ng-template #tipInfo>
  <div class="tip-tip">
    <div class="tip-info">
      <span *ngIf="!isMobile" class="material-icons arrow-up">arrow_drop_up</span>
      <app-close-btn type="sheet" top="10px" right="10px"></app-close-btn>
      <div class="title">Help Ketto help more people</div>
      <div class="line"></div>
      <div class="desc">Ketto relies on tips from contributors like you so that we can stay as a 100% free fundraising platform for our fundraisers. We also use the tips to:</div>
      <div class="info">
        <div class="item">
          <i class="material-icons">fiber_manual_record</i>
          <span class="bullet">Run marketing campaigns to raise awareness for our fundraisers like this one.</span>
        </div>
        <div class="item">
          <i class="material-icons">fiber_manual_record</i>
          <span class="bullet">Keep the lights on for Ketto.</span>
        </div>
        <div class="item">
          <i class="material-icons">fiber_manual_record</i>
          <span class="bullet">Visit and meet with people in need to help them create fundraising pages.</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #tipInfo2>
  <div class="tip-info tip-info-txt">
    <app-close-btn type="sheet" top="10px" right="10px"></app-close-btn>
    <div class="title">Help us stay a Free Fundraising Platform</div>
    <div class="line"></div>
    <div class="info">
      <div class="bullet">With the contribution you offer, Ketto will be able:</div>
      <div class="item">
        <i class="material-icons">check_circle</i>
        <span class="bullet">To raise awareness regarding integral social causes</span>
      </div>
      <div class="item">
        <i class="material-icons">check_circle</i>
        <span class="bullet">Continue to offer better solutions and reach out to more people</span>
      </div>
      <div class="item">
        <i class="material-icons">check_circle</i>
        <span class="bullet">Put in all our efforts to make sure that all those in need are funded</span>
      </div>
      <div class="item">
        <i class="material-icons">check_circle</i>
        <span class="bullet">Stay a 100% free fundraising platform</span>
      </div>
      <div class="bullet">We have chosen a different approach. Will you support it?</div>
    </div>
  </div>
</ng-template>


